export default "__VITE_ASSET__ebd2dfd2__"